import React, { useEffect, useRef } from "react";
import { Switch, Select, Divider, Collapse } from "antd";
import dayjs from 'dayjs';
import { sc2Timestamps, sc3Timestamps, sc4Timestamps, sc5Timestamps } from './utils';
import leau from '../assets/images/leau.png';
import station from '../assets/images/station-limni.png';
import circle from '../assets/images/blue-circle.png';
import CustomIcon from "./CustomIcon";
import stationM from '../assets/images/diffusion.png';  

const PanelControl = ({
    showStations,
    showWatershed,
    showEmprise,
    showRivers,
    showMeteoBasins,
    showIsochrone,
    setSelectedDepartments,
    setSelectedScenario,
    departmentsList,
    setShowEmprise,
    setShowIsochrone,
    setShowMeteoBasins,
    setShowStations,
    setShowRivers,
    setShowWatershed,
    setOpen,
    setSteps,
    stationsList,
    setSelectedSearchStation,
}) => {
  const ref40 = useRef(null);
  const ref41 = useRef(null);
  const ref42 = useRef(null);
  const ref43 = useRef(null);
  const ref46 = useRef(null);
  const ref47 = useRef(null);
  const ref48 = useRef(null);

  const layers = [
    { key: 'emprise', label: 'Emprise', checked: showEmprise },
    { key: 'isochrone', label: 'Isochrone 96', checked: showIsochrone },
    { key: 'waterShed', label: 'Bassin versants', checked: showWatershed },
    { key: 'rivers', label: 'Rivières', checked: showRivers },
    { key: 'meteoBasin', label: 'Bassins météo', checked: showMeteoBasins },
    { key: 'stations', label: 'Stations', checked: showStations },
  ];

  const legends = [
    { src: leau, label: 'DSEA', alt: 'DSEA' },
    { src: station, label: 'Limnimétriques', alt: 'limnimétrique' },
    { src: circle, label: 'Sans prédictions', alt: 'sans prédictions'},
    { src: stationM, label: 'Station pluviométrique', alt: 'station pluviométrique'}
  ];

  const steps = [
    {
      title: 'Panneau de contrôle',
      description: "Le panneau de contrôle permet de personnaliser l'affichage en choisissant les éléments parmi la liste ci dessous",
      target: () => ref40.current,
    },
    {
      title: 'Panneau de contrôle',
      description: "Il existe 3 évènements de prédictions. Choisissez en un pour afficher les données de prédiction, par défaut l'évènement de janvier 2021 à avril 2021 est activé",
      target: () => ref41.current,
    },
    {
      title: 'Panneau de contrôle',
      description: "Un accès rapide via la recherche d'une station vous permet de la localiser sur la carte",
      target: () => ref47.current,
    },
    {
      title: 'Panneau de contrôle',
      description: "vous pouvez recherche dans la liste mais aussi directement en tapant le nom de la station souhaitée",
      target: () => ref48.current,
    },
    {
      title: 'Panneau de contrôle',
      description: 'Par défaut tous les départements sont affichés. Vous pouvez afficher une liste de départements choisis depuis le sélecteur',
      target: () => ref42.current,
    },
    {
      title: 'Panneau de contrôle',
      description: (
        <ul>
          <li> Emprise : il s'agit de la zone d'étude prise dans son ensemble</li>
          <li> Isochrone 96: il s'agit de la limite au delà de laquelle on dépasse les 96 heures</li>
          <li> Bassins versants: Ils apparaissent au survol de la souris quand ils sont activés</li>
          <li> Rivières: ensemble des cours d'eau par ordre d'importance</li>
          <li> Bassins météo: zones déterminées par les sous-bassins-versants sur lesquelles nous récupérons les précipitations cumulées</li>
          <li>Stations: toutes les tations utilisées pour la récupération des données pour établir les modèles de prédiction par IA</li>
        </ul>
      ),
      target: () => ref46.current,
    },
    {
      title: 'Panneau de contrôle',
      description: "Il s'agit de la légende des stations, seules les stations ayant un picto présentent des prédictions",
      target: () => ref43.current,
    },
  ]

  const formatTimestamps = (startDate, endDate) =>
    `(${dayjs.unix(startDate).format('YYYY-MM-DD')} / ${dayjs.unix(endDate).format('YYYY-MM-DD')})`;

  const sc2TimestampsInterval = formatTimestamps(sc2Timestamps.startDate, sc2Timestamps.endDate);
  const sc3TimestampsInterval = formatTimestamps(sc3Timestamps.startDate, sc3Timestamps.endDate);
  const sc4TimestampsInterval = formatTimestamps(sc4Timestamps.startDate, sc4Timestamps.endDate);
  const sc5TimestampsInterval = formatTimestamps(sc5Timestamps.startDate, sc5Timestamps.endDate);

    const handleDepartmentChange = (value) => {
        if (value.includes('all')) {
          setSelectedDepartments(departmentsList.filter(dep => dep.depCode !== 'none' && dep.depCode !== 'all').map(dep => dep.depCode));
        } else setSelectedDepartments(value);
      };
    const toggleLayer = (layer) => {
        switch (layer) {
          case 'waterShed':
            setShowWatershed(!showWatershed);
            break;
          case 'emprise':
            setShowEmprise(!showEmprise);
            break;
          case 'rivers':
            setShowRivers(!showRivers);
            break;
          case 'isochrone':
            setShowIsochrone(!showIsochrone);
            break;
          case 'meteoBasin':
            setShowMeteoBasins(!showMeteoBasins);
            break;
          case 'stations':
            setShowStations(!showStations);
            break;
          default:
            break;
        }
      };

      const options = [
        { label: `sc2 ${sc2TimestampsInterval}`, value: 'sc2 (2021-01-01 / 2021-04-01)' },
        { label: `sc3 ${sc3TimestampsInterval}`, value: 'sc3 (2021-12-29 / 2022-01-25)' },
        { label: `sc4 ${sc4TimestampsInterval}`, value: 'sc4 (2023-01-01 / 2023-02-01)' },
        { label: `sc5 ${sc5TimestampsInterval}`, value: 'sc5 (2023-08-01 / 2024-11-01)' },
      ];

      useEffect(() => {
        const value = options[0].value;
        setSelectedScenario(value.split(' ')[0]);
      }, []);
      
    const handleScenarioChange = (value) => {
        const scenarioBase = value.split(' ')[0];
        setSelectedScenario(scenarioBase);
      };

      const handleSearchStationChange = (value) => {
        setSelectedSearchStation(value);
      };

    return (
        <aside ref={ref40} className="panel-control">
          <CustomIcon setOpen={setOpen} setSteps={setSteps} steps={steps} />
          <Collapse
            collapsible="header"
            defaultActiveKey={['1']}
            ghost
            items={[
              {
                key: '1',
                label: <h3 ref={ref41}>Évènements</h3>,
                children: <Select
                style={{ width: '100%' }}
                placeholder="Sélectionner un évènement"
                onChange={handleScenarioChange}
                defaultValue={options[0]}
                options={options}
              />
              }
            ]}
            />
          <Collapse
          collapsible="header"
          defaultActiveKey={['1']}
          ghost
          items= {[
            {
              key: '1',
              label: <h3 ref={ref47}>Stations</h3>,
              children: <div ref={ref48}><Select
              className="panel-select"
              showSearch
              placeholder="Rechercher une station par nom"
              optionFilterProp="label"
              onChange={handleSearchStationChange}
              options={stationsList.map((station) => ({
                label: station.stationName,
                value: station.stationCode,
              }))}
            />
            </div>
            }
          ]}
          />
          <Collapse
          collapsible="header"
          defaultActiveKey={['1']}
          ghost
          items={[
            {
              key: '1',
              label: <h3 ref={ref42}>Calques</h3>,
              children: <>
              <Collapse
              collapsible="icon"
              defaultActiveKey={'1'}
              ghost
              items={[
                {
                  key: '1',
                  label: <p className="mv-7">Départements</p>,
                  children: <Select
                  mode="multiple"
                  className="select-multiple"
                  placeholder="Départements"
                  defaultValue={['77', '91', '75', '94']}
                  onChange={handleDepartmentChange}
                  options={departmentsList.map((dep) => ({
                    label: dep.depName,
                    value: dep.depCode,
                  }))}
                />

                }
              ]}
              />
              {layers.map((layer) => (
                <div ref={ref46} className="mv-7" key={layer.key}>
                  <Switch checked={layer.checked} onChange={() => toggleLayer(layer.key)} size="small" />
                  <span className="panel-control-label">{layer.label}</span>
                </div>
              ))}
              {showStations && (
                <div ref={ref43} className="legends">
                  {legends.map(({ src, label, alt, className = '' }) => (
                    <div className="legend-item" key={label}>
                      <img src={src} alt={alt} className={`legend-picto ${className}`} />
                      <span className="italic">{label}</span>
                    </div>
                  ))}
                </div>
              )}
              </>
            }
          ]}
          />
        </aside>
    );
}

export default PanelControl;
